export const confirmationResult = {
  confirmed: "confirmed",
  rejected: "rejected",
}
